import {Panes, TextField} from '@management-ui/core';
import React from 'react';

const Fields = ({referrer = {}, prefix = '', multiplePanes = true, children}) => {
  return (
    <Panes
      entity={referrer}
      prefix={prefix}
      panes={[
        {
          title: 'Referrer Details',
          fields: [
            <TextField
              name="name"
              prefix={prefix}
              label="Name"
              rules={{required: 'Please enter a name'}}
            />
          ]
        }
      ]}
      title={multiplePanes ? null : 'Referrer Details'}
    >{children}</Panes>
  );
};

export default Fields;
